import React from 'react';
import { ButtonLink } from '../../../../components';
import { t } from '../../../../i18n';
import UrlTo from '../../../../url-to';
import { giftCardIcon, keyIcon, scribbleShineLeftImage } from '../../../assets';
import './styles.scss';

const GiftCardOverlayHeader = () => (
  <section className="gift-card-overlay-header">
    <h1>{t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.TITLE')}</h1>
    <h2 className="gift-card-overlay-header__gift-card-title">{t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.GIFT_CARD')}</h2>
    <img className="gift-card-overlay-header__shine" src={scribbleShineLeftImage} alt="Shine" />
    <div className="gift-card-overlay-header__buttons-row">
      <ButtonLink
        href={UrlTo.coursesGiftCardCheckout()}
        type="green"
        className="gift-card-overlay-header__link"
        text={
          <span>
            <img src={giftCardIcon} alt={t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.GIFT_CARD')} />
            {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_GIFT_CARD')}
          </span>
        }
      />
      <ButtonLink
        href={UrlTo.coursesGiftCardRedeem()}
        type="green"
        className="gift-card-overlay-header__link"
        text={
          <span>
            <img src={keyIcon} alt="Code" />
            {t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.ACTIVATE_GIFT_CARD')}
          </span>
        }
      />
    </div>
    <p className="gift-card-overlay-header__page-description">
      {t('DIGITAL_COURSES.GIFT_CARD_OVERVIEW.PAGE_DESCRIPTION')}
    </p>
  </section>
);

export default GiftCardOverlayHeader;
